import { Box, Typography } from '@mui/material';
import HowToUseTitle from './HowToUseTitle';

/** Figma 10040:6780 — HOW TO USE steps */
export default function CouponHowToUse({ steps = [] }) {
  return (
    <Box sx={{ width: '100%', maxWidth: 480, mx: 'auto' }}>
      <HowToUseTitle />

      {steps.length > 0 ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          {steps.map((step, index) => (
            <Box key={index} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  border: '1px solid rgba(255, 255, 255, 0.35)',
                  display: 'grid',
                  placeItems: 'center',
                  flexShrink: 0,
                  bgcolor: 'rgba(255, 255, 255, 0.06)',
                }}
              >
                <Typography
                  sx={{
                    color: '#fff',
                    fontWeight: 900,
                    fontSize: 18,
                    lineHeight: 1,
                  }}
                >
                  {String(index + 1).padStart(2, '0')}
                </Typography>
              </Box>
              <Typography
                sx={{
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: 16,
                  lineHeight: '24px',
                  letterSpacing: '0.8px',
                  pt: 0.75,
                }}
              >
                {step}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : null}
    </Box>
  );
}
